export default function PageHero() {
  return (
    <section className="relative h-[400px] bg-gradient-to-br from-cyan-500 via-cyan-400 to-blue-400 flex items-center justify-center">
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/10"></div>
      <div className="relative z-10 text-center">
        <h1 className="text-5xl lg:text-6xl font-bold text-white mb-4">
          法人・アクセス情報
        </h1>
        <nav className="flex items-center justify-center gap-2 text-white/90 text-sm">
          <a href="/" className="hover:text-white transition-colors cursor-pointer">トップ</a>
          <i className="ri-arrow-right-s-line"></i>
          <span>法人・アクセス情報</span>
        </nav>
      </div>
    </section>
  );
}
